import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchRepatriationsTransactionsConfirm from '../../api/RepatriationsTransactionsConfirmAPI';
import { REPATRIATIONS_TRANSACTIONS_CONFIRM_REQUEST } from '../actions/types/RepatriationsTransactionsConfirmActionsTypes';
import {
  postRepatriationsTransactionsConfirmSuccessActionCreator,
  postRepatriationsTransactionsConfirmFailureActionCreator,
} from '../actions/RepatriationsTransactionsConfirmActions';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';

function* doRepatriationsTransactionsConfirmWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchRepatriationsTransactionsConfirm, action.payload);
    yield put(postRepatriationsTransactionsConfirmSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.repatriations.transaction.confirm.success'),
    }));
  } catch (error) {
    yield put(postRepatriationsTransactionsConfirmFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'app.server.error'),
    }));
  }
}

function* doRepatriationsTransactionsConfirmWatcher() {
  yield takeLatest(REPATRIATIONS_TRANSACTIONS_CONFIRM_REQUEST, doRepatriationsTransactionsConfirmWorker);
}

export default doRepatriationsTransactionsConfirmWatcher;
